export default "__VITE_ASSET__C1S1glHK__"